import React, { useState, useEffect } from 'react';
import { TextField, Button, Box, Typography, Paper } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';

const StudentNameForm = ({ onSubmit, onSkip, isVerification = true }) => {
  const [name, setName] = useState('');
  const [error, setError] = useState('');
  
  // Carica il nome da localStorage, se disponibile
  useEffect(() => {
    try {
      const savedName = localStorage.getItem('last_student_name');
      if (savedName) {
        setName(savedName);
      }
    } catch (e) {
      console.error('Errore nel caricamento del nome:', e);
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (isVerification && (!name || name.trim() === '')) {
      setError('Per favore, inserisci il tuo nome per iniziare la verifica.');
      return;
    }
    
    // Anche in caso di esercitazione con input vuoto, procediamo
    const studentName = name.trim() || 'Anonimo';
    
    // Salva il nome in localStorage per usi futuri (solo se non è vuoto)
    if (studentName !== 'Anonimo') {
      try {
        localStorage.setItem('last_student_name', studentName);
      } catch (e) {
        console.error('Errore nel salvataggio del nome:', e);
      }
    }
    
    onSubmit(studentName);
  };

  return (
    <Paper elevation={0} sx={{
      padding: 3,
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
      backdropFilter: 'blur(8px)',
      borderRadius: 2,
      border: '1px solid rgba(255, 255, 255, 0.2)',
      mt: 2
    }}>
      <Typography variant="h5" component="h2" sx={{
        color: 'white',
        textAlign: 'center',
        mb: 2,
        fontWeight: 'bold'
      }}>
        {isVerification 
          ? "Inserisci il tuo nome per iniziare la verifica" 
          : "Inserisci il tuo nome (opzionale)"}
      </Typography>
      
      <Typography variant="body1" sx={{
        color: 'white',
        textAlign: 'center',
        mb: 3
      }}>
        {isVerification 
          ? "Il tuo nome verrà associato ai risultati della verifica." 
          : "Puoi inserire il tuo nome o continuare senza nome."}
      </Typography>
      
      <form onSubmit={handleSubmit}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <TextField
            fullWidth
            variant="outlined"
            label="Nome e Cognome"
            value={name}
            onChange={(e) => setName(e.target.value)}
            error={!!error}
            helperText={error}
            required={isVerification}
            InputProps={{
              startAdornment: <PersonIcon sx={{ mr: 1, color: 'rgba(255,255,255,0.7)' }} />,
            }}
            sx={{
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: 'rgba(255, 255, 255, 0.3)',
                },
                '&:hover fieldset': {
                  borderColor: 'rgba(255, 255, 255, 0.5)',
                },
                '&.Mui-focused fieldset': {
                  borderColor: '#19696A',
                },
              },
              '& .MuiInputLabel-root': {
                color: 'rgba(255, 255, 255, 0.7)',
              },
              '& .MuiInputBase-input': {
                color: 'white',
              },
              '& .MuiFormHelperText-root': {
                color: '#df4634',
              },
            }}
          />
          
          <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, position: 'relative' }}>
            <Button
              type="submit"
              variant="contained"
              size="large"
              startIcon={<PlayArrowIcon />}
              sx={{
                backgroundColor: '#19696A',
                color: 'white',
                '&:hover': {
                  backgroundColor: '#135758',
                },
                minWidth: '180px',
                fontWeight: 'bold'
              }}
            >
              {isVerification ? "Inizia Verifica" : "Inizia"}
            </Button>
          </Box>
        </Box>
      </form>
    </Paper>
  );
};

export default StudentNameForm;